var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "LoginForm" }, [
    _vm.isApiSuccess
      ? _c("div", { staticClass: "login-form-row" }, [
          _c("h2", [_vm._v(_vm._s(_vm.trans("forgot_password_title_success")))])
        ])
      : _vm._e(),
    _vm.isApiSuccess
      ? _c("div", { staticClass: "login-form-row" }, [
          _c("p", [
            _vm._v(_vm._s(_vm.trans("forgot_password_description_success")))
          ])
        ])
      : _vm._e(),
    !_vm.isApiSuccess
      ? _c("div", { staticClass: "login-form-row" }, [
          _c("h2", [_vm._v(_vm._s(_vm.trans("forgot_password_title")))])
        ])
      : _vm._e(),
    !_vm.isApiSuccess
      ? _c("div", { staticClass: "login-form-row" }, [
          _c("p", [_vm._v(_vm._s(_vm.trans("forgot_password_description")))])
        ])
      : _vm._e(),
    !_vm.isApiSuccess
      ? _c("div", { staticClass: "form-row" }, [
          _c("div", { staticClass: "label-wrapper" }, [
            _c("div", { staticClass: "label-left" }, [
              _c("label", { attrs: { for: "email" } }, [
                _vm._v(_vm._s(_vm.trans("email_title")))
              ])
            ]),
            _c("div", { staticClass: "label-right" })
          ]),
          _c("div", { staticClass: "input-wrapper" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formModel.email,
                  expression: "formModel.email"
                }
              ],
              class: { error: _vm.$v.formModel.email.$error || _vm.isApiError },
              attrs: { type: "text", name: "email", id: "email" },
              domProps: { value: _vm.formModel.email },
              on: {
                focusout: function($event) {
                  return _vm.$v.formModel.email.$touch()
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.formModel, "email", $event.target.value)
                }
              }
            }),
            _vm.$v.formModel.email.$error
              ? _c("span", { staticClass: "error" }, [
                  _vm._v(" " + _vm._s(_vm.trans("email_error")) + " ")
                ])
              : _vm._e(),
            _vm.isApiError && !_vm.$v.formModel.email.$error
              ? _c("span", { staticClass: "error" }, [_vm._v(" ")])
              : _vm._e()
          ])
        ])
      : _vm._e(),
    !_vm.isApiSuccess
      ? _c("div", { staticClass: "form-row" }, [
          _c("div", { staticClass: "input-wrapper" }, [
            _c(
              "button",
              {
                class: { "btn-primary": true, loading: _vm.isLoading },
                on: {
                  click: function($event) {
                    return _vm.submit()
                  }
                }
              },
              [
                _c("div", { staticClass: "loader" }, [
                  _c("img", { attrs: { src: "/assets/images/loader.svg" } })
                ]),
                _c("div", { staticClass: "btn-text" }, [
                  _vm._v(" " + _vm._s(_vm.trans("send_button")) + " ")
                ])
              ]
            ),
            _c("div", { class: { "be-error": true } }, [
              _vm.isApiError
                ? _c("span", { staticClass: "error" }, [
                    _vm._v(
                      " " + _vm._s(_vm.trans("forgot_password_error")) + " "
                    )
                  ])
                : _vm._e()
            ])
          ])
        ])
      : _vm._e(),
    !_vm.isApiSuccess
      ? _c("div", { staticClass: "form-row" }, [
          _c("div", { staticClass: "input-wrapper" }, [
            _c(
              "button",
              {
                class: { "btn-primary-reverse": true },
                on: {
                  click: function($event) {
                    return _vm.back()
                  }
                }
              },
              [
                _c("div", { staticClass: "btn-text" }, [
                  _vm._v(" " + _vm._s(_vm.trans("back_button")) + " ")
                ])
              ]
            )
          ])
        ])
      : _vm._e(),
    _vm.isApiSuccess
      ? _c("div", { staticClass: "form-row" }, [
          _c("div", { staticClass: "input-wrapper" }, [
            _c(
              "button",
              {
                class: { "btn-primary-reverse": true },
                on: {
                  click: function($event) {
                    return _vm.back()
                  }
                }
              },
              [
                _c("div", { staticClass: "btn-text" }, [
                  _vm._v(" " + _vm._s(_vm.trans("back_button")) + " ")
                ])
              ]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }